import type { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import MonitoringDashboard from './MonitoringDashboard';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div
      className="flex flex-col min-h-screen"
      style={{
        backgroundColor: 'var(--bg-secondary)',
        color: 'var(--text-primary)',
      }}
    >
      {/* <div className="bg-yellow-100 border-b border-yellow-200 text-yellow-800 px-4 py-2 text-center text-sm font-medium">
        This site is under development. Some functionality may not work as
        expected.
      </div> */}
      <Header />
      <main className="flex-1 mx-auto w-full px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8">
        {children}
      </main>
      <Footer />
      {/* Show monitoring dashboard only in development or if explicitly enabled */}
      {import.meta.env.VITE_ENABLE_PERFORMANCE_MONITORING === 'true' && (
        <MonitoringDashboard />
      )}
    </div>
  );
};

export default Layout;
